import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  LogoLoader,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { Link, useNavigate } from "react-router-dom";
import { mapTableRows } from "../../../../utils/mapTableRows";
//
import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeesStart,
  setEmployeeProfileUiid,
} from "../../../../redux/slices/employee/employeeSlice";
import {
  getValueByKey,
  formatWords,
  dateFormator,
  getEmployeeId,
} from "../../../../utils";
import { usePagination } from "../../../../hooks";
const AllConsultants = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [sortConfig, setSortConfig] = useState({ field: "uiid", direction: 1 });
  const { loading, error, employees, totalCount } = useSelector(
    (state) => state.employee,
  );
  const isLoading = loading;
  const paginationMemory = localStorage.getItem("all-consultants-limit") || 25;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    paginationMemory,
    (newPage, newLimit) => {
      dispatch(getEmployeesStart({ page: newPage, limit: newLimit }));
    },
  );

  const tableData = employees?.data || []; // Add null check with default empty array

  const handleEdit = (row) => {
    alert(row.code);
  };
  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : 1,
    }));
  };

  const columns = [
    {
      key: "code",
      label: "Code",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
            >
              {getEmployeeId(row.uiid, row.employmentType)}
            </Link>
          </span>
        </div>
      ),

      sortfun: () => handleSort("uiid"),
    },
    {
      key: "firstName",
      label: "First Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.firstName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-2">
            <Avatar
              alt={row.firstName}
              size="sm"
              outline
              src={row.profilePhotoUrl}
            />
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
              className="truncate max-w-[200px]"
            >
              {row.firstName}
            </Link>
          </div>
        </SmartTooltip>
      ),

      sortfun: () => handleSort("firstName"),
    },
    {
      key: "lastName",
      label: "Last Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.lastName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
            >
              {row.lastName}
            </Link>
          </div>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("lastName"),
    },
    {
      key: "middleName",
      label: "Middle Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.middleName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
            >
              {row.middleName}
            </Link>
          </div>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("middleName"),
    },
    {
      key: "employmentType",
      label: "Employment Type",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {formatWords(
              "",
              getValueByKey(row.employmentType, "EmploymentType"),
            )}
          </Link>
        </div>
      ),
      sortfun: () => handleSort("employmentType"),
    },
    {
      key: "status",
      label: "Employee Status",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <StatusTags
              tag={formatWords("", getValueByKey(row.status, "EmployeeStatus"))}
            />
          </Link>
        </div>
      ),
      sortfun: () => handleSort("status"),
    },
    {
      key: "email",
      label: "Email ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">{row.email.primary}</span>
          </Link>
        </div>
      ),
      sortfun: () => handleSort("email.primary"),
    },
    {
      key: "alternateEmailId",
      label: "Alternate Email ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">{row.email.secondary || "-"}</span>
          </Link>
        </div>
      ),
      sortfun: () => handleSort("email.secondary"),
    },
    {
      key: "category",
      label: "Category",
      sortfun: () => handleSort("category"),
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {row?.category ? row?.category : "-"}
          </Link>
        </div>
      ),
    },
    {
      key: "location",
      label: "Country",
      width: "text-nowrap",
      render: (row) => (
        <Link
          to="/employee/employee-profile"
          onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
        >
          <div className="flex items-center gap-1">{row.location.country}</div>
        </Link>
      ),
      sortfun: () => handleSort("location.country"),
    },
    {
      key: "cityState",
      label: "City/State",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => {
        const value = `${row?.location?.city || ""}, ${row?.location?.state || ""}`;

        return (
          <SmartTooltip
            description={value}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="flex items-center gap-1 line-clamp-1!">
              <Link
                to="/employee/employee-profile"
                onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
              >
                {value}
              </Link>
            </div>
          </SmartTooltip>
        );
      },
      sortfun: () => handleSort("location.state"),
    },
    {
      key: "fullAddress",
      label: "Full Address",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
            description={row.location.address1}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
        <Link
          to="/employee/employee-profile"
          onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
        >
          <div className="flex items-center gap-1 line-clamp-1!">{row.location.address1}</div>
        </Link>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("location.address1"),
    },

    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[350px]!",
      sortfun: () => handleSort("location.address1"),
      render: (row) => (
        <SmartTooltip
          description={row.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <div className="flex items-center gap-1 line-clamp-1!">
              {row?.jobTitle || "-"}
            </div>
          </Link>
        </SmartTooltip>
      ),
    },
    {
      key: "joinDate",
      label: "Date of Joining",
      render: (row) => (
        <Link
          to="/employee/employee-profile"
          onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
        >
          {dateFormator(row.joinDate, "month-day-year")}
        </Link>
      ),
      sortfun: () => handleSort("joinDate"),
    },
    {
      key: "",
      label: "Action",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit"
          size="xs"
          color="black"
          onClick={() => handleEdit(row)}
        />
      ),
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  useEffect(() => {
    dispatch(
      getEmployeesStart({
        limit,
        page,
        filters: {
          employmentType: { type: "NONE", value: 2 },
          "isExit.status": { type: "NONE", value: false },
          onBench: { type: "NONE", value: false },
          all: {
            type: "SEARCH",
            value: searchValue,
          },
        },
        ret: "uiid employmentType profilePhotoUrl firstName middleName lastName status email category location jobTitle joinDate",
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    const setLimitInLocalStorage = () => {
      localStorage.setItem("all-consultants-limit", limit || 0);
    };
    setLimitInLocalStorage();
  }, [dispatch, page, limit, sortConfig, searchValue]); // Empty array will cause it to run once when the component mounts

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };
  return (
    <div className="flex flex-col overflow-hidden">
      <TableAdv
        tableId={`employees_allconsultants`}
        rows={mappedRows}
        columns={columns}
        //fixedCol={3}
        showSlNo
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverSerchValue={searchValue}
        serverOnSearch={handleSearch}
        toolbarRight={{
          search:true,
          filter:true
        }}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AllConsultants;
